import {
  Avatar,
  AvatarProps,
  Box,
  FlexProps,
  HStack,
  Tag,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { CopyButton } from "components/buttons/CopyButton";
import { useShortAddress } from "hooks/useShortAddress";
import React from "react";

interface Props extends FlexProps {
  address: string;
  noAvatar?: boolean;
  avatarSize?: AvatarProps["size"];
  isOwner?: boolean;
  enableCopying?: boolean;
  textProps?: TextProps;
  inline?: boolean;
}

// TODO: WalletAddress vs Person
export const WalletAddress: React.FC<Props> = ({
  avatarSize = "2xs",
  noAvatar,
  address,
  isOwner,
  enableCopying,
  textProps,
  inline = false,
  ...props
}) => {
  const shortAddress = useShortAddress(address);

  return (
    <Box
      {...(inline && {
        display: "inline-block",
        ml: 1,
        color: "white",
      })}
      {...props}
    >
      <HStack spacing={2} alignItems="center">
        {!noAvatar && <Avatar size={avatarSize} />}
        <Text variant="body" {...textProps}>
          {shortAddress ?? address}
        </Text>
        {enableCopying && (
          <CopyButton text={address || ""} variant="link" size="xs" />
        )}
        {isOwner && (
          <Box pl={2}>
            <Tag variant="filled">You</Tag>
          </Box>
        )}
      </HStack>
    </Box>
  );
};
